/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pricing_Compare_Group_Every_PlanInputs */



/**
* | output |
* | --- |
* | "On every plan" |
*
* @param {Pricing_Compare_Group_Every_PlanInputs} inputs
* @param {{ locale?: "en" | "ru" }} options
* @returns {LocalizedString}
*/
export const pricing_compare_group_every_plan = /** @type {((inputs?: Pricing_Compare_Group_Every_PlanInputs, options?: { locale?: "en" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pricing_Compare_Group_Every_PlanInputs, { locale?: "en" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ru") return /** @type {LocalizedString} */ ("На любом тарифе")
	return /** @type {LocalizedString} */ ("On every plan")
});